module.exports = __webpack_public_path__ + "helveticaneue_thin-webfont.9f6c7d4509f5c5c7bd92.woff";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helveticaneue_thin-webfont.woff
// module id = ../../../../../src/assets/fonts/helveticaneue_thin-webfont.woff
// module chunks = styles